import { isArray, uniqueId } from 'lodash';

const addIdToItem = (annotationItem) => ({
  id: uniqueId('annotation_'),
  ...annotationItem,
});

const addIdToValueItems = (annotationValue) => {
  if (isArray(annotationValue)) {
    return annotationValue.map(addIdToItem);
  }
  return annotationValue;
};

export const addIdToAnnotationsItems = (annotations) =>
  annotations.map((annotation) => ({
    ...annotation,
    value: addIdToValueItems(annotation.value),
  }));
